import { apiSlice } from '../apiSlice';
import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	AchievementTreasureFilter,
	TaskAchievementCollectionSeriesDTO,
	TaskAchievementRewardDetailDTO,
} from '../DTO/task/treasure.interface';

export const treasureApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAchievementTreasureList: builder.query<
			SuccessResponse<Paginated<TaskAchievementCollectionSeriesDTO>>,
			AchievementTreasureFilter
		>({
			query: (body) => ({
				url: `/web/task/achievement/collection/series/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['AchievementTreasureList'],
		}),
		getAchievementTreasureSortList: builder.query<
			SuccessResponse<TaskAchievementCollectionSeriesDTO[]>,
			null
		>({
			query: (body) => ({
				url: `/web/task/achievement/collection/series/sort`,
				method: 'GET',
			}),
		}),
		sortAchievementTreasure: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/task/achievement/collection/sort`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['AchievementTreasureList'],
		}),
		getAchievementTreasureDetail: builder.query<
			SuccessResponse<TaskAchievementCollectionSeriesDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/task/achievement/collection/series/${id}`,
				method: 'GET',
			}),
			providesTags: ['AchievementTreasureDetail'],
		}),
		updateAchievementTreasureDetail: builder.mutation<
			SuccessResponse<any>,
			TaskAchievementCollectionSeriesDTO
		>({
			query: (body) => ({
				url: `/web/task/achievement/collection/series/${body.id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['AchievementTreasureDetail'],
		}),
		getAchievementTreasureSingleList: builder.query<
			SuccessResponse<Paginated<TaskAchievementRewardDetailDTO>>,
			AchievementTreasureFilter
		>({
			query: (body) => ({
				url: `/web/task/achievement/collection/series/${body.id}/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['AchievementTreasureSingleList'],
		}),
		createAchievementTreasureSingle: builder.mutation<
			SuccessResponse<any>,
			TaskAchievementRewardDetailDTO
		>({
			query: (body) => ({
				url: `/web/task/achievement/collection/series/${body.id}`,
				method: 'POST',
				body,
			}),
		}),
		updateAchievementTreasureSingle: builder.mutation<
			SuccessResponse<any>,
			TaskAchievementRewardDetailDTO
		>({
			query: (body) => ({
				url: `/web/task/achievement/collection/single/${body.id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['AchievementTreasureSingleDetail'],
		}),
		getAchievementTreasureSingleSortList: builder.query<
			SuccessResponse<TaskAchievementRewardDetailDTO[]>,
			string
		>({
			query: (id) => ({
				url: `/web/task/achievement/collection/series/${id}/sort`,
				method: 'GET',
			}),
		}),
		setAchievementTreasureSingleStatus: builder.mutation<
			SuccessResponse<any>,
			{ publishList: { published: boolean; id: string }[] }
		>({
			query: (body) => ({
				url: `/web/task/achievement/collection/single/published`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: [
				'AchievementTreasureSingleList',
				'AchievementTreasureSingleDetail',
			],
		}),
		getAchievementTreasureSingleDetail: builder.query<
			SuccessResponse<TaskAchievementRewardDetailDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/task/achievement/collection/single/${id}`,
				method: 'GET',
			}),
			providesTags: ['AchievementTreasureSingleDetail'],
		}),
		deleteAchievementTreasureSingle: builder.mutation<
			SuccessResponse<any>,
			string
		>({
			query: (id) => ({
				url: `/web/task/achievement/collection/single/${id}`,
				method: 'DELETE',
			}),
		}),
		deleteAchievementTreasure: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/task/achievement/collection/series/{id}`,
				method: 'DELETE',
			}),
		}),
	}),
});

export const {
	useGetAchievementTreasureListQuery,
	useGetAchievementTreasureSortListQuery,
	useSortAchievementTreasureMutation,
	useGetAchievementTreasureDetailQuery,
	useUpdateAchievementTreasureDetailMutation,
	useGetAchievementTreasureSingleListQuery,
	useCreateAchievementTreasureSingleMutation,
	useUpdateAchievementTreasureSingleMutation,
	useGetAchievementTreasureSingleSortListQuery,
	useSetAchievementTreasureSingleStatusMutation,
	useGetAchievementTreasureSingleDetailQuery,
	useDeleteAchievementTreasureSingleMutation,
	useDeleteAchievementTreasureMutation,
} = treasureApiSlice;
